export const DELETE_USER = 'delete_user';
export const DELETE_USER_SUCCESSFUL = 'delete_user_successfull';
export const DELETE_USER_FAILED = 'delete_user_failed';



